<h2 mat-dialog-title>Gestion des documents - {{ field().name }}</h2>
<mat-dialog-content>
  <div class="documents-container" [class.dragging]="isDragging()" (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
    <mat-progress-bar mode="indeterminate" *ngIf="isUploading()" class="upload-progress"></mat-progress-bar>
    <div class="documents-actions" [class.disabled-actions]="isUploading()" *ngIf="!isReadonly()">
      <input type="file" multiple hidden #fileInput (change)="onFilesSelected($event)" />
      <button mat-flat-button color="primary" (click)="fileInput.click()">
        <mat-icon aria-hidden="true">cloud_upload</mat-icon>
        Ajouter des documents
      </button>
    </div>

    <div class="documents-list" *ngIf="field().documents?.length; else noDocuments">
      <div class="document-row" *ngFor="let doc of field().documents">
        <div class="document-icon">
          <mat-icon>{{ getFileIcon(doc.contentType) }}</mat-icon>
        </div>
        <div class="document-info">
          <span class="file-name" [title]="doc.fileName">{{ doc.fileName }}</span>
          <span class="file-size">{{ formatFileSize(doc.size) }}</span>
        </div>
        <div class="document-actions">
          <button mat-icon-button title="Télécharger" (click)="downloadDocument(doc)">
            <mat-icon aria-hidden="true">download</mat-icon>
          </button>
          <button mat-icon-button color="warn" title="Supprimer" (click)="askDeleteDocument(doc)" *ngIf="!isReadonly()">
            <mat-icon aria-hidden="true">delete</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <ng-template #noDocuments>
      <div class="no-documents">
        <mat-icon>folder_open</mat-icon>
        <p>Aucun document associé à ce champ.</p>
        <p class="drag-hint">Glissez-déposez vos fichiers ici ou cliquez sur le bouton ci-dessus.</p>
      </div>
    </ng-template>

    <div class="error-zone" *ngIf="field().minPhotosNbr && (field().documents?.length || 0) < field().minPhotosNbr!">
      <mat-icon>error_outline</mat-icon>
      <span>Au moins {{ field().minPhotosNbr }} document(s) requis</span>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Fermer</button>
</mat-dialog-actions>

<app-confirm-dialog *ngIf="showDeleteConfirm()" [title]="'Supprimer le document'"
  [message]="'Voulez-vous vraiment supprimer ce document ? Cette action est irréversible.'"
  (confirmed)="confirmDeleteDocument()" (cancelled)="cancelDeleteDocument()"></app-confirm-dialog>

